// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var HttpStatusCode = function (x) {
    return x;
};
var tsBridgeHttpStatusCode = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("HttpStatusCode")("__brandHttpStatusCode"));
    }
};
var writeHttpStatusCode = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showHttpStatusCode = Data_Show.showNumber;
var readHttpStatusCode = Simple_JSON.readNumber;
var ordHttpStatusCode = Data_Ord.ordNumber;
var newtypeHttpStatusCode = {
    Coercible0: function () {
        return undefined;
    }
};
var makeHttpStatusCode = HttpStatusCode;
var eqHttpStatusCode = Data_Eq.eqNumber;
export {
    HttpStatusCode,
    makeHttpStatusCode,
    unwrap,
    newtypeHttpStatusCode,
    eqHttpStatusCode,
    ordHttpStatusCode,
    showHttpStatusCode,
    readHttpStatusCode,
    writeHttpStatusCode,
    tsBridgeHttpStatusCode
};
//# sourceMappingURL=index.js.map
